import { render, staticRenderFns } from "./MovieCity.vue?vue&type=template&id=5b4f2c38&scoped=true"
import script from "./MovieCity.vue?vue&type=script&lang=js"
export * from "./MovieCity.vue?vue&type=script&lang=js"
import style0 from "./MovieCity.vue?vue&type=style&index=0&id=5b4f2c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4f2c38",
  null
  
)

export default component.exports